'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/secondBefore.js
// module id = 205
// module chunks = 0